import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
// import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import Iframe from "react-iframe";
import { Button } from "primereact/button";
import { URL_MAP_DEFAULT } from "../../../service/Config";
//CSS

import P419Dialog from "./P419Dialog";

export default function P412() {
    const history = useHistory();
    const toast = useRef(null);

    // const [loading, setLoading] = useState(false);
    const [userRole, setUserRole] = useState("A");

    //SEARCH
    const [dataSearch, setDataSearch] = useState({ contractNo: "", userId: dataUserSession() ? dataUserSession().userId : "", token: dataUserSession() ? dataUserSession().token : "" });
    const [isUrlMap, setIsUrlMap] = useState("");

    const [isDialog, setIsDialog] = useState(false);

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        } else {
            setUserRole(dataUserSession().userRole);
            if (history.location.state) {
                setDataSearch({
                    ...dataSearch,
                    ...history.location.state,
                });
            }
        }
    }, []);

    useEffect(() => {
        setIsUrlMap(URL_MAP_DEFAULT() + "/Map419?userId=" + dataSearch.userId + "&token=" + dataSearch.token + "&contractNo=" + dataSearch.contractNo);
    }, [dataSearch]);

    const checkDash = () => {
        if (userRole === "2") {
            history.push("/208");
        } else {
            history.push("/400");
        }
    };

    const openDialogDownload = () => {
        setIsDialog(true);
    };

    return (
        <>
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">ลงแนวเส้นท่อใน GIS</h2>
                        <hr /> */}
                        <div className="p-grid  p-fluid">
                            <div className="p-field p-col-12 p-md-6">
                                <Button className="p-button-secondary p-button btn-long-top-responsive" icon="pi pi-arrow-left" label="กลับหน้าจอหลัก" style={{ width: 170, marginLeft: "5px" }} onClick={() => checkDash()} />
                            </div>
                            <div className="p-field p-col-12 p-md-6" style={{ display: "flex" }}>
                                <Button className="p-button-secondary p-button btn-long-top-responsive" icon="pi pi-download" label="ดาวน์โหลดคู่มือการบันทึกแนวเส้นท่อ GIS" style={{ width: 170, marginLeft: "auto" }} onClick={() => openDialogDownload()} />
                            </div>
                        </div>
                        <Iframe url={isUrlMap} width="100%" height="512px" id="myId" className="myClassname" display="initial" position="relative" />
                    </div>
                </div>
            </div>
            <P419Dialog dialog={isDialog} setDialog={setIsDialog} />
        </>
    );
}
